var lists_default = {
  "fontElementMap": "_-3pCJ",
  "orderedlist": "jWVnG",
  "bulletedlist": "dNJ8f",
  "listItem": "qD7Da"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
